import { get, patch, post, remove } from '@/api/base'

export const getUsers = async params => {
  const response = await get({
    path: `admin/users`,
    params,
  })
  return response.success
    ? {
        users: response.data.users,
        pagination: response.data.meta.pagination,
      }
    : null
}

export const getUser = async userUuid => {
  const response = await get({
    path: `admin/users/${userUuid}`,
  })
  return response.success ? response.data.user : null
}

export const updateUser = async (userUuid, userParams) => {
  const response = await patch({
    path: `admin/users/${userUuid}`,
    params: userParams,
  })
  return response.success ? response.data.user : null
}

export const createUser = async userParams => {
  const response = await post({
    path: `admin/users`,
    params: userParams,
  })
  return response.success ? response.data.user : null
}

export const deleteUser = async userUuid => {
  const response = await remove({
    path: `admin/users/${userUuid}`,
  })
  return response.success
}
